import { render, staticRenderFns } from "./DailyTips.vue?vue&type=template&id=3fc1b0e5&scoped=true&lang=pug"
import script from "./DailyTips.vue?vue&type=script&lang=js"
export * from "./DailyTips.vue?vue&type=script&lang=js"
import style0 from "./DailyTips.vue?vue&type=style&index=0&id=3fc1b0e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc1b0e5",
  null
  
)

export default component.exports